import React from 'react';
import { useTranslation } from 'react-i18next';
import { Card, CardContent, Grid, TextField, FormControl, InputLabel, Select, MenuItem, Button } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import RefreshIcon from '@mui/icons-material/Refresh';

const RepresentativeFilters = ({ filters, onFilterChange, limit, onLimitChange, onRefresh, loading }) => {
    const { t } = useTranslation();

    const handleInputChange = (field) => (event) => {
        onFilterChange(field, event.target.value);
    };

    return (
        <Card sx={{ mb: 3 }}>
            <CardContent>
                <Grid container spacing={2} alignItems="center">
                    <Grid item xs={12} md={3}>
                        <TextField
                            fullWidth
                            label={t('common.search')}
                            value={filters.search}
                            onChange={handleInputChange('search')}
                            InputProps={{ startAdornment: <SearchIcon color="action" /> }}
                        />
                    </Grid>
                    <Grid item xs={12} md={2}>
                        <FormControl fullWidth>
                            <InputLabel>{t('common.status')}</InputLabel>
                            <Select
                                value={filters.isActive}
                                label={t('common.status')}
                                onChange={handleInputChange('isActive')}
                            >
                                <MenuItem value="all">{t('common.all')}</MenuItem>
                                <MenuItem value="active">{t('status.active')}</MenuItem>
                                <MenuItem value="inactive">{t('status.inactive')}</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={2}>
                        <FormControl fullWidth>
                            <InputLabel>{t('common.sortBy')}</InputLabel>
                            <Select
                                value={filters.sortBy}
                                label={t('common.sortBy')}
                                onChange={handleInputChange('sortBy')}
                            >
                                <MenuItem value="name">{t('representatives.name')}</MenuItem>
                                <MenuItem value="doctorsCount">{t('representatives.doctorsCount')}</MenuItem>
                                <MenuItem value="createdAt">{t('common.createdAt')}</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={2}>
                        <FormControl fullWidth>
                            <InputLabel>{t('common.itemsPerPage')}</InputLabel>
                            <Select value={limit} label={t('common.itemsPerPage')} onChange={onLimitChange}>
                                <MenuItem value={10}>10</MenuItem>
                                <MenuItem value={25}>25</MenuItem>
                                <MenuItem value={50}>50</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <Button fullWidth variant="outlined" startIcon={<RefreshIcon />} onClick={onRefresh} disabled={loading}>
                            {t('common.refresh')}
                        </Button>
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    );
};

export default RepresentativeFilters;